import { render, staticRenderFns } from "./GameInTesting.vue?vue&type=template&id=22c07bfa"
import script from "./GameInTesting.vue?vue&type=script&lang=js"
export * from "./GameInTesting.vue?vue&type=script&lang=js"
import style0 from "./GameInTesting.vue?vue&type=style&index=0&id=22c07bfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports